function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { Tag } from '../Tag';
export const SIMPLE_BLOCK_IMAGE_TAG_POSITIONS = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
export const StyledImageTag = styled(Tag).withConfig({
  componentId: "aui__sc-kyvsbl-0"
})(["position:absolute;", ":1rem;", ":1rem;"], ({
  $position
}) => $position.split('-')[0], ({
  $position
}) => $position.split('-')[1]);
export const ImageTag = ({
  position = 'top-left',
  ...props
}) => /*#__PURE__*/React.createElement(StyledImageTag, _extends({
  $position: position,
  size: "large"
}, props));